import { render } from "./DataSourceMonitor.vue?vue&type=template&id=367978e2&scoped=true"
import script from "./DataSourceMonitor.vue?vue&type=script&lang=js"
export * from "./DataSourceMonitor.vue?vue&type=script&lang=js"

import "./DataSourceMonitor.vue?vue&type=style&index=0&id=367978e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-367978e2"]])

export default __exports__